import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Story } from '../components/Story';
import { Problem } from '../components/Problem';
import { ThreePortals } from '../components/ThreePortals';
import { ProductPresentation } from '../components/ProductPresentation';
import { BonusStack } from '../components/BonusStack';
import { ValueTable } from '../components/ValueTable';
import { Testimonials } from '../components/Testimonials';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { FAQ } from '../components/FAQ';
import { Guarantee } from '../components/Guarantee';
import { PricingCTA } from '../components/PricingCTA';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen flex flex-col font-body text-warm-brown-dark bg-cream" data-id="element-346">
      <UrgencyBar data-id="element-347" />
      <main data-id="element-348">
        <Hero data-id="element-349" />
        <PainPoints data-id="element-350" />
        <Story data-id="element-351" />
        <Problem data-id="element-352" />
        <ThreePortals data-id="element-353" />
        <ProductPresentation data-id="element-354" />
        <BonusStack data-id="element-355" />
        <ValueTable data-id="element-356" />
        <Testimonials data-id="element-357" />
        <WhoIsItFor data-id="element-358" />
        <PricingCTA data-id="element-359" />
        <FAQ data-id="element-360" />
        <Guarantee data-id="element-361" />
        <EmotionalClose data-id="element-362" />
      </main>
      <Footer data-id="element-363" />
    </div>;
}